import Header from "@/components/Header";
import Hero from "@/components/Hero";
import AboutProgram from "@/components/AboutProgram";
import WhoCanParticipate from "@/components/WhoCanParticipate";
import HowItWorks from "@/components/HowItWorks";
import Benefits from "@/components/Benefits";
import AboutTaboca from "@/components/AboutTaboca";
import FinalCTA from "@/components/FinalCTA";

import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <AboutProgram />
        <WhoCanParticipate />
        <HowItWorks />
        <Benefits />
        <AboutTaboca />
        <FinalCTA />
        
      </main>
      <Footer />
    </div>
  );
};

export default Index;
